(() => {
  const composer = document.querySelector('[data-review-composer]');
  if (!composer) return;
  const ready = () => {
    if (!composer.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link, .jdgm-form')) return false;
    document.documentElement.classList.add('hz-review-composer-ready');
    const write = composer.querySelector('[data-review-write]');
    if (write) write.disabled = false;
    return true;
  };
  if (ready()) return;
  const observer = new MutationObserver(() => { if (ready()) observer.disconnect(); });
  observer.observe(composer, {childList: true, subtree: true});
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
})();
